export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Geek Cafe',
          url: 'https://www.geekcafe.com',
          logo: 'https://cdn-media.geekcafe.com/assets/img/logos/geek-cafe-logo.png',
          description: 'AWS Cloud Architecture, DevOps, and Application Development Services',
          sameAs: [
            // Add your social media profiles here
            // 'https://twitter.com/geekcafe',
            'https://linkedin.com/company/geekcafe',
            'https://github.com/geekcafe'
          ],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Service',
            availableLanguage: 'English'
          },
          areaServed: 'US',
          knowsAbout: ['AWS', 'Cloud Architecture', 'DevOps', 'Python', '.NET', 'API Design']
        })
      }
    ]
  })
})
